import { styled } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";

const StyledToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, colors }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: colors?.background?.popover,
    borderRadius: "1rem",
    color: colors?.text?.primary,
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
    // fontSize: 11,
  },
}));

export default StyledToolTip;
